






import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class ActionButtons extends Vue {
  @Prop(Function) private cancelHandler: any;
  @Prop(Function) private confirmHandler: any;
  @Prop({ default: 'Cancel' }) private cancelText!: string;
  @Prop({ default: 'primary' }) private cancelType!: string;
  @Prop({ default: 'Confirm' }) private confirmText!: string;
  @Prop({ default: 'success' }) private confirmType!: string;
}
